import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  wrapperaddNewProretycheckDuplicate: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
  },
  containerFiledItem: {
    display: "flex",
    flexDirection: "row",
    gap: "32px",
    width: "100%",
  },
  titleFiled: {
    maxWidth: "280px",
    minWidth: "160px",
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    color: theme.palette.text.secondary,
  },
  containerInputFiled: {
    width: "100%",
  },
  inputFullWidth: {
    width: "100% !important",
    maxWidth: "100% !important",
    [theme.breakpoints.down("426")]: {
      width: "100% !important",
    },
  },
  colorTextInputFiled: {
    color:`${theme.palette.text.placeholder} !important`,
  },
  backgroundColorTextInputFiled: {
    background:`none !important`
  },
}));
